"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkSetResourceStatusRequest = void 0;
const __1 = require("..");
function checkSetResourceStatusRequest(object) {
    return (0, __1.check)(object, (0, __1.hasString)("resourceId").nonEmpty(), (0, __1.hasChoice)("resourceType", ["project"]), (0, __1.hasChoice)("statusName", ["active", "archived", "deleted"]), (0, __1.hasObject)("context", (0, __1.hasChoice)("platform", ["ios", "android", "web"]))).explain();
}
exports.checkSetResourceStatusRequest = checkSetResourceStatusRequest;
//# sourceMappingURL=SetResourceStatusRequest.js.map